// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/fonts/fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Rubik+Glitch&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #F6F6F6;
  --red: #CC2E2E;
  --red-hover: #fa0000;
  --blue: #2E5ACC;
}

.title {
  color: var(--red);
  font-size: 4.2rem;
  font-weight: 400;
  font-family: "Rubik Glitch";
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
}
.title img {
  width: 2.7rem;
}
@media (max-width: 1420px) {
  .title {
    font-size: 3.2rem;
  }
}
@media (max-width: 890px) {
  .title {
    font-size: 2.8rem;
  }
}
@media (max-width: 480px) {
  .title {
    font-size: 2.5rem;
    gap: 10px img;
    gap-width: 2.4rem;
  }
}

.slick-arrow {
  display: none !important;
}

.slick-slider {
  outline: none;
}
.slick-slider * {
  outline: none;
}

.title2 {
  max-width: 1100px;
  font-size: 2.8rem;
}
@media (max-width: 1420px) {
  .title2 {
    font-size: 2.4rem;
    max-width: 800px;
  }
}
@media (max-width: 520px) {
  .title2 {
    font-size: 1.8rem;
  }
}
.title2 strong {
  color: var(--red);
  font-family: "Rubik Glitch";
  font-weight: 400;
  font-size: 2.8rem;
}
@media (max-width: 1420px) {
  .title2 strong {
    font-size: 2.5rem;
  }
}
@media (max-width: 520px) {
  .title2 strong {
    font-size: 2.1rem;
  }
}
.title2 img {
  width: 2.5rem;
  margin-left: 15px;
}

.container {
  position: relative;
  padding: 0 100px 0 350px;
  overflow: hidden;
}
@media (max-width: 1640px) {
  .container {
    padding: 0 100px 0 240px;
  }
}
@media (max-width: 1420px) {
  .container {
    padding: 0 80px 0 200px;
  }
}
@media (max-width: 1060px) {
  .container {
    padding: 0 80px 0 60px;
  }
}
@media (max-width: 890px) {
  .container {
    padding: 0 40px 0 40px;
  }
}
@media (max-width: 520px) {
  .container {
    padding: 0 25px 0 25px;
  }
}

@media (max-width: 890px) {
  .links_network {
    display: none !important;
  }
}
.slick-arrow::before {
  color: var(--red) !important;
  font-size: 1.3rem !important;
}

.slick-prev::before {
  margin-right: -60px !important;
}

.slick-next::before {
  margin-left: -60px !important;
}

.slick-dots {
  bottom: 0px !important;
}
.slick-dots button::before {
  font-size: 0.8rem !important;
}
.slick-dots li button::before {
  color: var(--red) !important;
  opacity: 0.5 !important;
}
.slick-dots li.slick-active button::before {
  opacity: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAaA;EACG,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;AATH;;AAYA;EACG,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AATH;AAWG;EACG,aAAA;AATN;AAYG;EAdH;IAeM,iBAAA;EATJ;AACF;AAWG;EAlBH;IAmBM,iBAAA;EARJ;AACF;AAUG;EAtBH;IAuBM,iBAAA;IACA,aAAA;IAEG,iBAAA;EARP;AACF;;AAYA;EACG,wBAAA;AATH;;AAYA;EACG,aAAA;AATH;AAUG;EACG,aAAA;AARN;;AAYA;EACG,iBAAA;EACA,iBAAA;AATH;AAWG;EAJH;IAKM,iBAAA;IACA,gBAAA;EARJ;AACF;AAWG;EAVH;IAWM,iBAAA;EARJ;AACF;AAUG;EACG,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;AARN;AAUM;EANH;IAOM,iBAAA;EAPP;AACF;AASM;EAVH;IAWM,iBAAA;EANP;AACF;AASG;EACG,aAAA;EACA,iBAAA;AAPN;;AAWA;EACG,kBAAA;EACA,wBAAA;EACA,gBAAA;AARH;AAUG;EALH;IAMM,wBAAA;EAPJ;AACF;AASG;EATH;IAUM,uBAAA;EANJ;AACF;AAQG;EAbH;IAcM,sBAAA;EALJ;AACF;AAOG;EAjBH;IAkBM,sBAAA;EAJJ;AACF;AAMG;EArBH;IAsBM,sBAAA;EAHJ;AACF;;AAMA;EACG;IACG,wBAAA;EAHJ;AACF;AAQA;EACG,4BAAA;EACA,4BAAA;AANH;;AASA;EACG,8BAAA;AANH;;AASA;EACG,6BAAA;AANH;;AASA;EACG,sBAAA;AANH;AAQG;EACG,4BAAA;AANN;AAUM;EACG,4BAAA;EACA,uBAAA;AART;AAaM;EACG,qBAAA;AAXT","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Rubik+Glitch&display=swap');\n@import url(\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css\");\n@import url(\"./assets/fonts/fonts.css\");\n\n\n// --xxl: 1640px\n// --xl: 1320px\n// --xl: 1140px\n// --lg: 960px\n// --md: 720px\n// --sm: 540px\n// --xs: 440px\n\n:root {\n   --white: #F6F6F6;\n   --red: #CC2E2E;\n   --red-hover: #fa0000;\n   --blue: #2E5ACC;\n}\n\n.title{\n   color: var(--red);\n   font-size: 4.2rem;\n   font-weight: 400;\n   font-family: 'Rubik Glitch'; \n   display: inline-flex;\n   justify-content: flex-start;\n   align-items: center;\n   gap: 15px;\n\n   img{\n      width: 2.7rem;\n   }\n\n   @media (max-width: 1420px) {\n      font-size: 3.2rem;\n   }\n\n   @media (max-width: 890px) {\n      font-size: 2.8rem;\n   }\n\n   @media (max-width: 480px) {\n      font-size: 2.5rem;\n      gap: 10px\n      img{\n         width: 2.4rem;\n      }\n   }\n}\n\n.slick-arrow{\n   display: none !important;\n}\n\n.slick-slider{\n   outline: none;\n   *{\n      outline: none;\n   }\n}\n\n.title2{\n   max-width: 1100px;\n   font-size: 2.8rem;\n\n   @media (max-width: 1420px) {\n      font-size: 2.4rem;\n      max-width: 800px;\n   }\n\n\n   @media (max-width: 520px) {\n      font-size: 1.8rem;\n   }\n   \n   strong {\n      color: var(--red);\n      font-family: 'Rubik Glitch';\n      font-weight: 400;\n      font-size: 2.8rem;\n\n      @media (max-width: 1420px) {\n         font-size: 2.5rem;\n      }\n\n      @media (max-width: 520px) {\n         font-size: 2.1rem;\n      }\n   }\n\n   img{\n      width: 2.5rem;\n      margin-left: 15px;\n   }\n}\n\n.container{\n   position: relative;\n   padding: 0 100px 0 350px;\n   overflow: hidden;\n\n   @media (max-width: 1640px) {\n      padding: 0 100px 0 240px;\n   }\n\n   @media (max-width: 1420px) {\n      padding: 0 80px 0 200px;\n   }\n\n   @media (max-width: 1060px) {\n      padding: 0 80px 0 60px;\n   }\n\n   @media (max-width: 890px) {\n      padding: 0 40px 0 40px;\n   }\n\n   @media (max-width: 520px) {\n      padding: 0 25px 0 25px;\n   }\n}\n\n@media (max-width: 890px) {\n   .links_network{\n      display: none !important;\n   }\n}\n\n\n//slick\n.slick-arrow::before{\n   color: var(--red) !important;\n   font-size: 1.3rem !important;\n}\n\n.slick-prev::before{\n   margin-right: -60px !important;\n}\n\n.slick-next::before{\n   margin-left: -60px !important;\n}\n\n.slick-dots{\n   bottom:  0px !important;\n\n   button::before{\n      font-size: 0.8rem !important;\n   }\n\n   li{\n      button::before{\n         color: var(--red) !important;\n         opacity: 0.5 !important;\n      }\n   }\n\n   li.slick-active{\n      button::before{\n         opacity: 1 !important;\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
